import {createReducer} from '../utils';
import {SET_CUSTOMER_FORM, RESET_CUSTOMER_FORM} from '../constants';

const initialState = {
    anrede:'',
    vorname:'',
    nachname:'',
    vornamekind:'',
    nachnamekind:'',
    geburtstagkind:'',
    geburtstag:'',
    strasse:'',
    hausnummer:'',
    plz:'',
    ort:'',
    land:'',
    email:'',
    telefon:'',
    fax:'',
    kontoinhaber:'',
    schoolname:'',
    bank:'',
    iban:'',
    bic:'',
    support:[],
    documents:[],
    upload:[],
    customdata:[]
};


export default createReducer(initialState, {
    [SET_CUSTOMER_FORM]: (state, payload) => {
       return Object.assign({}, state, {
            anrede: payload.anrede,
            vorname: payload.vorname,
            nachname: payload.nachname,
            vornamekind: payload.vornamekind,
            nachnamekind: payload.nachnamekind,
            geburtstagkind: payload.geburtstagkind,
            geburtstag: payload.geburtstag,
            strasse: payload.strasse,
            hausnummer: payload.hausnummer,
            plz: payload.plz,
            ort: payload.ort,
            land: payload.land,
            email: payload.email,
            telefon: payload.telefon,
            fax: payload.fax,
            schoolname: payload.schoolname,
            kontoinhaber: payload.kontoinhaber,
            bank: payload.bank,
            iban: payload.iban,
            bic: payload.bic,
            support: payload.support,
            documents: payload.documents,
            upload: payload.upload,
            customdata: payload.customdata
        });
    },
    [RESET_CUSTOMER_FORM]: (state, payload) => {
       return Object.assign({}, state, initialState);
    }
});



// WEBPACK FOOTER //
// ./src/reducers/customer.js